import { useQuery } from '@tanstack/react-query';
import { useDataService } from '@/lib/service-context';

/** Counts shown as red badges on the Espace Pro sidebar group and on
 *  Commandes Pro / Commissions sub-items. Mirrors the Tunielec admin
 *  sidebar. Refreshed every 60s. */
export function useProPendingCounts() {
  const ds = useDataService();

  const customersQ = useQuery({
    queryKey: ['admin-pro-customers', 'pending'],
    queryFn: () => ds.proCustomers.listForTenant({ status: 'pending' }),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });

  const ordersQ = useQuery({
    queryKey: ['admin-pro-commandes', 'en_attente'],
    queryFn: () => ds.proCommandes.list({ status: 'en_attente' }),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });

  const commissionsQ = useQuery({
    queryKey: ['admin-pro-wallet-movements', 'pending-commission'],
    queryFn: () => ds.proWallet.listMovements({ status: 'pending', type: 'commission' }),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });

  const pendingPros = customersQ.data?.length ?? 0;
  const pendingCommandes = ordersQ.data?.length ?? 0;
  const pendingCommissions = commissionsQ.data?.length ?? 0;

  return {
    pendingPros,
    pendingCommandes,
    pendingCommissions,
    proTotal: pendingPros + pendingCommandes + pendingCommissions,
  };
}
